// extracted by mini-css-extract-plugin
export default {"appleModal":"etz0f0nGA5XF2R6VaJ3c","iconContainer":"zDR24MlYzBmA_DjBiJe1","content":"IOJzfbr7VEX7E37qLClz","pulse":"wLS2Zr6jC1KmcCyS9bnj"};